import { render, staticRenderFns } from "./AxSignup.vue?vue&type=template&id=191107b6&scoped=true&"
import script from "./AxSignup.vue?vue&type=script&lang=ts&"
export * from "./AxSignup.vue?vue&type=script&lang=ts&"
import style0 from "./AxSignup.vue?vue&type=style&index=0&id=191107b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191107b6",
  null
  
)

export default component.exports